// src/pwa/pages/allBookListPwa.jsx
import React, { useState } from 'react';
import usePwaAuth from '../hooks/usePwaAuth';

import usePublicQueue from '../../shared/hooks/usePublicQueue';
import PublicQueueList from '../../shared/components/PublicQueueList';
import LoadingCard from '../../shared/components/LoadingCard';

import FooterPwa from '../components/FooterPwa';

// Firestore の識別フィールド名
const PWA_USER_ID_FIELD = 'pwaId';

export default function PwaAll() {
  // 1) PWA 認証（uid: undefined=判定中, null=未ログイン(再試行中想定), "PWA_..."=OK）
  const { uid, error } = usePwaAuth();

  // LINE版相当: 自分のIDが確定するまで待つ（エラー時は進める）
  const myIdResolved = (typeof uid === 'string') || !!error;

  // 2) キュー取得（順序維持のため常に呼ぶ。ID確定後に渡す）
  const queue = usePublicQueue({
    userId: (typeof uid === 'string') ? uid : null,
    userIdField: PWA_USER_ID_FIELD,
  });

  // 3) ローディング条件（LINE版のロジック踏襲）
  const loading =
    (uid === undefined) ||                      // PWA認証の判定中
    !myIdResolved ||
    !queue.runtimeReady ||
    (queue.inhouseOn === true && (
      !queue.rowsReady ||
      ((typeof uid === 'string') && !queue.mineResolved)
    ));

  // 4) 画面分岐
  if (error) {
    return (
      <div className="pwa-container">
        <div className="pwa-card">
          <h1 className="pwa-title">認証エラー</h1>
          <p className="pwa-desc">
            端末認証に失敗しました。ページを再読み込みしてください。改善しない場合は管理者へご連絡ください。
          </p>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>
            {error?.message}
          </pre>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="pwa-container">
        <LoadingCard />
      </div>
    );
  }

  return (
    <>
      <PublicQueueList
        inhouseOn={queue.inhouseOn}
        waitCount={queue.waitCount}
        nowStr={queue.nowStr}
        list={queue.list || []}
        myAheadCount={queue.myAheadCount}
        showMineBadge={true}
      />

      {/* デバッグ補助（任意） */}
      <div className="line-muted" style={{marginTop:12}}>
        uid: {uid} ／ inhouseOn: {String(queue.inhouseOn)} ／ isOnlineOpen: {String(queue.isOnlineOpen)}
      </div>
      
      <FooterPwa />
    </>
  );
}